<template>
	<div class="" v-loading='loading'>
	    <el-button type="primary" @click="dialogFormVisible = true">{{$t('lin_global.resetPass')}}</el-button>
	    <el-button type="primary" @click="edit(userinfo.userid,userinfo.nickName)">{{$t('app_editProfile')}}</el-button>
      <el-button type="primary" @click="mfaClick">{{userinfo.bindMfa==1?'MFA '+$t('lin_btn.unbind'):'MFA'}}</el-button>

        <div class="source">
          <el-row class='gPageBorder gTopMg gPdTB'>
		      <el-col :span='12'>
		        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.user') ">
		            {{ userinfo.userName}}
		          </el-form-item>
		        </el-form>
		      </el-col>

		      <el-col :span='12'>
		        <el-form class='gShowRightForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.nickName') ">
		            {{userinfo.nickName}}
		          </el-form-item>
		        </el-form>
		      </el-col>

		      <el-col :span='12'>
		        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.phoneNum2') ">
		            {{ userinfo.phoneNum}}
		          </el-form-item>
		        </el-form>
		      </el-col>

		      <el-col :span='12'>
		        <el-form class='gShowRightForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.roleName') ">
		            {{ userinfo.roleName}}
		          </el-form-item>
		        </el-form>
		      </el-col>
		      <el-col :span='12'>
		        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.label_areaid') ">
		            {{ userinfo.mechanismName}}
		          </el-form-item>
		        </el-form>
		      </el-col>

		      <el-col :span='12'>
		        <el-form class='gShowRightForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('lin_global.zhengshuType') ">
		            {{certTypeName}}
		          </el-form-item>
		        </el-form>
		      </el-col>


		      <el-col :span='12'>
		        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('app_mgsys')">
		            {{userinfo.ip}}
		          </el-form-item>
		        </el-form>
		      </el-col>

		      <el-col :span='12'>
		        <el-form class='gShowRightForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('app_edcode') ">
		            {{userinfo.code}}
		          </el-form-item>
		        </el-form>
		      </el-col>


          <el-col :span='12'>
		        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
		          <el-form-item :label="$t('app_allowiplg')">
		            {{userinfo.limitIp}}
		          </el-form-item>
		        </el-form>
		      </el-col>

		      
		  </el-row>

          <!-- <el-row class="mt20">
          	<el-form :model="userinfo" label-position="left" id="userInfo" label-width="150px">
          		<el-form-item :label="$t('lin_global.user')">
                  {{ userinfo.userName}}
                </el-form-item>
                <el-form-item :label="$t('lin_global.nickName')">
                  <el-input style="width: 300px;" v-model="userinfo.nickName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item :label="$t('lin_global.roleName')">
                  {{ userinfo.roleName }}
                </el-form-item>
                <el-form-item :label="$t('lin_global.label_areaid')">
                  {{ userinfo.mechanismName }}
                </el-form-item>
              <el-form-item :label="$t('lin_global.zhengshuType')">
                {{ userinfo.certType == 0?this.$t('lin_global.ziguan'):this.$t('lin_global.daiguan') }}
              </el-form-item>   
          	</el-form>
          </el-row> -->

        </div>

		<el-dialog class='gDia'  :title="$t('lin_global.revisePass')" v-model="dialogFormVisible" label-width='12.5%'>
		  <el-form :model="formPwd" :rules="rules2" ref="formPwd">
		    <el-form-item :label="$t('lin_global.oldPass')" :label-width="formLabelWidth">
		      <el-input v-model="formPwd.oldPass" type="password" auto-complete="off"></el-input>
		    </el-form-item>
		    <el-form-item :label="$t('lin_global.newPass')" :label-width="formLabelWidth" prop="pass">
		      <el-input v-model="formPwd.pass" type="password" auto-complete="off"></el-input>
		    </el-form-item>
		    <el-form-item :label="$t('lin_global.comfirmPass')" :label-width="formLabelWidth" prop="checkPass">
		       <el-input v-model="formPwd.checkPass" type="password" auto-complete="off"></el-input>
		    </el-form-item>
		    <el-form-item :label-width="formLabelWidth">
		      <el-button @click="dialogFormVisible = false">{{$t('lin_btn.cancel')}}</el-button>
			    <el-button type="primary" @click="submitForm('formPwd')">{{$t('lin_btn.confirm')}}</el-button>
		    </el-form-item>

		  </el-form>
		  
		</el-dialog>

		<el-dialog class='gDia' :title="$t('app_editProfile')" v-model="isEditNick" >
		  <el-form model="" rules="" ref="">
		    <el-form-item :label="$t('lin_global.nickName')" :label-width="formLabelWidth">
		      <el-input v-model="nick"></el-input>
		    </el-form-item>
		    <el-form-item :label="$t('lin_global.phoneNum')" :label-width="formLabelWidth">
		      <el-input v-model="phone"></el-input>
		    </el-form-item>
		    <el-form-item label="" :label-width="formLabelWidth">
		      <el-button type="" @click="cancelNick()">{{$t('app_cancel')}}</el-button>
		      <el-button type="primary" @click="saveNick()">{{$t('lin_btn.save')}}</el-button>
		    </el-form-item>
		  </el-form>
		  
		</el-dialog>

    <el-dialog
		cclass="gDia"
		@open="bindOpen"
		@close="closeBind"
		ttitle="$t('app_mulfcau')"
		v-model="isbind"
		size="small"
		> 
		<div id="mfbindfr">
			<el-steps :space="310" :active="active" finish-status="success">
				<el-step :title="$t('app_ckidt')"></el-step>
				<el-step :title="$t('app_istapp')"></el-step>
				<el-step :title="$t('app_bindmfa')"></el-step>
			</el-steps>
			<div id="mfbind1" v-if="active==0">
				<h5>{{$t('app_bindsfdv')}}&nbsp;&nbsp;&nbsp;&nbsp;{{$t('lin_global.user')}}<label>{{brow.nickName}}</label>&nbsp;{{$t('app_psfwtsstepop')}}</h5>
				<el-input type="password" :placeholder="$t('app_ipaclgpsw')" v-model="mfafm.psw"></el-input>
			</div>
			<div id="mfbind2" v-if="active==1">
				<h5>{{$t('app_bindsfdv')}}&nbsp;&nbsp;&nbsp;&nbsp;{{$t('lin_global.user')}}<label>{{brow.nickName}}</label>&nbsp;{{$t('app_psfwtsstepop')}}</h5>
				<h4>{{$t('app_phdnalyappggidck')}}</h4>
				<h3>{{$t('app_ipappstsagidck')}}</h3>
				<h3>{{$t('app_adappmksagidck')}}</h3>
				<h4>{{$t('app_afistclnxitbpagiinx')}}</h4>
			</div>
			<div id="mfbind3" v-if="active==2">
				<h5>{{$t('app_bindsfdv')}}&nbsp;&nbsp;&nbsp;&nbsp;{{$t('lin_global.user')}}<label>{{brow.nickName}}</label>{{$t('app_psfwtsstepop')}}</h5>
				<h4>{{$t('app_usalyagidckscqrc6code')}}</h4>
				<div id="mfaqrcode" ref="mfaqrcode" ></div>
				<el-input :placeholder="$t('app_sixnumb')" v-model="mfafm.code"></el-input>
			</div>
		</div>
		<div slot="footer" class="dialog-footer" v-loading="dld">
			<el-button type="" v-if="active>0" @click="stepClick(0)">{{$t('app_lsstep')}}</el-button>
			<el-button type="" v-if="active<2" @click="stepClick(1)">{{$t('app_nxstep')}}</el-button>
			<el-button type="primary" v-if="active==2"  @click="bindRqs">{{$t('lin_btn.bind')}}</el-button>
		</div>
		</el-dialog>

		<el-dialog
		cclass="gDia"
		v-loading="logining"
		@close="closeUnbind"
		:title="$t('lin_btn.unbind')"
		v-model="isunbind"
		size="small"
		> 
		<div id="mfunbindfr">
			<h5>{{$t('app_sftkck')}}&nbsp;&nbsp;&nbsp;&nbsp;{{$t('app_ip6codeubac')}}&nbsp;<label>{{brow.nickName}}</label></h5>
			<h4>{{$t('app_plipopenalyappoggidckip6dycd')}}</h4>
			<el-input :placeholder="$t('app_sixnumb')" v-model="mfafm.code"></el-input>
		</div>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="unbindOpe">{{$t('app_sure')}}</el-button>
		</div>
		</el-dialog>

    </div>
</template>

<style>
	/* #mfbindfr {
		border:1px solid red;
	} */
	#mfbind1,#mfbind2,#mfbind3 {
		overflow: hidden;
		padding-top: 15px;
		box-sizing: border-box;
	}
	#mfbind1 .el-input {
		margin-top: 20px;
	}
	#mfbind1 h5,#mfbind2 h5, #mfbind3 h5 {
		padding-bottom: 5px;
		border-bottom: 1px solid lightgrey;
	}
	#mfbind1 h5 label,#mfbind2 h5 label, #mfbind3 h5 label {
		color: orange;
	}
	#mfaqrcode {
		margin-top: 15px;
	}
	#mfbind2 h4, #mfbind3 h4 {
		margin-top: 20px;
		font-weight: bold;
		font-size: 15px;
	}
	#mfbind2 h3, #mfbind3 h3 {
		margin-top: 10px;
	}
	#mfbind3 .el-input {
		margin-top: 20px;
	}
	#mfunbindfr h5 {
		padding-bottom: 5px;
		border-bottom: 1px solid lightgrey;
	}
	#mfunbindfr h5 label {
		color: orange;
	}
	#mfunbindfr h4 {
		margin: 20px 0 20px 0;
	}
</style>

<script>
var md5 = require("md5");
import QRCode from 'qrcodejs2'
import axios from "axios";
import { baseurl } from "../../api/url";
axios.defaults.withCredentials = true;
export default {
  name: "info",

  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("lin_global.plePassTips")));
      } else {
        if (this.formPwd.checkPass !== "") {
          this.$refs.formPwd.validateField("checkPass");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      var reg=/^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\W_])).{8,}$/
      if (value === "") {
        callback(new Error(this.$t("lin_global.plePassTipsAgain")));
      } else if (value !== this.formPwd.pass) {
        callback(new Error(this.$t("lin_global.pwdDisfault")));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t("app_pswtip")));
      } else {
        callback();
      }
    };
    return {
      dld: false,
      mfafm: {psw:'',code:''},
      qrres: '',
      brow: '',
      active: 0,
      isbind: false,
      isunbind:false,
      loading: 0,
      isEditNick: false,
      dialogFormVisible: false,
      formLabelWidth: "14.5%",
      formPwd: {
        oldPass: "",
        pass: "",
        checkPass: ""
      },
      rules2: {
        pass: [{ validator: validatePass, trigger: "blur" }],
        checkPass: [{ validator: validatePass2, trigger: "blur" }]
      },
      userinfo: {},
      nick: "",
      phone: ""
    };
  },
  created() {
    if (localStorage.getItem("userId")) {
      this.getUserInfo();
    } else {
      this.getInfo();
    }
  },
  computed: {
    certTypeName: function() {
      var name = "--";
      if (this.userinfo.certType == 0) {
        name = this.$t("lin_global.ziguan");
      } else if (this.userinfo.certType == 1) {
        name = this.$t("lin_global.daiguan");
      } else {
        name = this.$t("app_cerMgCustomer");
      }
      return name;
    }
  },
  mounted() { 
    
  },
  methods: {
    createQrcode () {
      new QRCode('mfaqrcode', {
      width:150,
      height: 150, // 高度
      text: this.qrres // 二维码内容
      // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      // background: '#f0f'
      // foreground: '#ff0'
      })
    },
    unbindOpe () {
      if (!this.mfafm.code) {
        this.$message.error(this.$t('app_inputNumber'))
        return
      }
      this.dld=true
      this.$mfaUnbind(this.brow.userid, this.mfafm.code, res => {
        this.dld=false
        if (res.status==200) {
          this.closeUnbind()
          if (localStorage.getItem("userId")) {
            this.getUserInfo();
          } else {
            this.getInfo();
          }
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      }, () => {
        this.dld=false
      })
    },
    closeUnbind () {
      this.isunbind=false
      this.mfafm.code = ''
    },
    bindRqs () {
      if (!this.mfafm.code) {
        this.$message.error(this.$t('app_inputNumber'))
        return
      }
      this.dld=true
      this.$mfaBind(this.brow.userid, this.mfafm.code, res => {
        this.dld=false
        if (res.status==200) {
          this.closeBind()
          if (localStorage.getItem("userId")) {
            this.getUserInfo();
          } else {
            this.getInfo();
          }
          this.$message.success(res.message)
        } else {
          this.$message.error(res.message)
        }
      }, () => {
        this.dld=false
      })
    },
    nextOpe (isnext) {
      if (isnext) {
        this.active=this.active+1>2?this.active:this.active+1
      } else {
        this.active=this.active-1==-1?this.active:this.active-1
      }
    },
    stepClick (isnext) {
      if (this.active==0) {
        if (!this.mfafm.psw) {
          this.$message.error(this.$t('lin_global.plePassTips'))
          return
        } else {
          //checkid
          this.dld=true
          this.$mfaIdCheck(this.brow.userid, md5(this.mfafm.psw), res => {
            this.dld=false
            if (res.status==200) {
              this.nextOpe(isnext)
            } else {
              this.$message.error(res.message)
            }
          }, '')
        }
      } else if (this.active==1) {
        this.nextOpe(isnext)
      } else if (this.active==2) {
        this.nextOpe(isnext)
      }
      
      switch (this.active) {
        case 2:
          this.$nextTick(() => {
            this.createQrcode()
          })
          break;
      }
    },
    bindOpen () {
      this.$mfaQrcode(this.brow.userid, res => {
        this.qrres = res.data?res.data.qrCode:''
      }, '')
    },
    closeBind () {
      this.isbind=false
      this.dld=false
      this.mfafm={psw:'',code:''}
    },
    mfaClick () {
      this.brow = this.userinfo
      if (this.userinfo.bindMfa==1) {
        //unbind
        this.isunbind=true
      } else {
        //bind
        this.isbind=true
      }
    },
    isLegalMobile(tel) {
      var sMobile = tel;
      var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$";
      var re = new RegExp(regex, "g");
      if (!re.test(sMobile)) {
        return false;
      } else {
        return true;
      }
    },
    cancelNick() {
      this.isEditNick = false;
    },
    saveNick() {
      if (!this.nick) {
        this.$message.error(this.$t("lin_global.nickNameTips"));
        return;
      }
      // if (!this.isLegalMobile(this.phone)) {
      if (!this.phone) {
        this.$message.error(this.$t("app_phoneIllegal"));
        return;
      }
      this.loading = 1;
      var userId = localStorage.getItem("userId");
      var params = { userId: userId, nickName: this.nick, phone: this.phone };
      axios.post(`${baseurl}/user/updateNickName.do`, params).then(res => {
        //console.log("打印看看返回信息")
        //console.log(res.data);
        this.loading = 0;
        if (res.data.status == 200) {
          this.$message.success(res.data.message);
          this.userinfo.nickName = this.nick;
          this.userinfo.phoneNum = this.phone;
          this.$store.dispatch("setNick", this.nick);
          this.nick = "";
          this.phone = "";
          this.isEditNick = false;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          var userId = localStorage.getItem("userId");
          var params = {
            userId: userId,
            // oldPwd: this.$sha256(this.formPwd.oldPass),
            // newPwd: this.$sha256(this.formPwd.checkPass),
            oldPwd: md5(this.formPwd.oldPass),
            newPwd: md5(this.formPwd.checkPass)
          };
          //console.log("打印修改密码传参")
          //console.log(params);
          axios.post(`${baseurl}/user/updatePassword.do`, params).then(res => {
            //console.log("打印看看登陆信息")
            //console.log(res.data);
            if (res.data.status == 200) {
              this.dialogFormVisible = false;
              this.$message.success(res.data.message);
            } else {
              this.dialogFormVisible = false;
              this.$message.error(res.data.message);
            }
          });
        } else {
          //console.log('error submit!!');
          return false;
        }
      });
    },
    onCancel: function() {},
    edit: function(userid, nickname) {
      this.isEditNick = true;
      this.nick = this.userinfo.nickName;
      this.phone = this.userinfo.phoneNum;
    },
    getUserInfo: function() {
      var userId = localStorage.getItem("userId");
      var params = { userId: userId };
      axios.post(`${baseurl}/user/getUserById.do`, params).then(res => {
        this.userinfo = res.data.data;
      });
    },
    getInfo: function() {
      let user = localStorage.getItem(
        "user"
      ); /*{'token':"6d614e11-5000-40d6-aa1e-3c2ba2f7d24b"}*/
      //console.log("打印token参数")
      //console.log(user)
      var params = { token: user };
      axios.post(`${baseurl}/user/getUser.do`, params).then(res => {

        this.userinfo = res.data.data;
        // this.$setWobj('keyInfo', {key: res.data.data.appkey, secret: res.data.data.secretkey})
        localStorage.setItem("userId", res.data.data.userid);
        localStorage.setItem("mechanismId", res.data.data.mechanismId);
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// info.vue?a31a1698